import { Box, Flex } from '@mantine/core'
import { motion } from 'framer-motion'
import type { ReactNode } from 'react'

import {
  articleEntranceTransition,
  slideUpAnimate,
  slideUpInitial
} from 'src/components/animations'

type Props = {
  imagePosition: 'left' | 'right'
  imagePanelSlot: ReactNode
  children: ReactNode
}

export const ArticleSideLayout = ({
  imagePosition,
  imagePanelSlot,
  children
}: Props) => (
  <motion.div
    initial={slideUpInitial}
    animate={slideUpAnimate}
    transition={articleEntranceTransition}
  >
    <Flex
      direction={{
        base: 'column',
        md: imagePosition === 'right' ? 'row-reverse' : 'row'
      }}
      align={{ base: 'stretch', md: 'flex-start' }}
      gap="xl"
      mb="xl"
    >
      <Box
        pos={{ base: 'relative', md: 'sticky' }}
        top={{ md: 180 }}
        w={{ base: '100%', md: '45%' }}
        style={{ flexShrink: 0, minHeight: 320 }}
      >
        {imagePanelSlot}
      </Box>
      {children}
    </Flex>
  </motion.div>
)
